const hasNewChanges = (newone: any, previous: any) => {
  return Object.keys(newone).every((k) => {
    //log((cmd as any)?.[k], '===' , (previous as any)?.[k], (cmd as any)?.[k] === (previous as any)?.[k])
    return (newone as any)?.[k] === (previous as any)?.[k]
  })
}
export default hasNewChanges
